import {Link, useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";

import { useAuth } from "../../context/AuthContext";
import api from "../../shared/AxiosConfig";
import {categoryApi} from "../../api"; // kendi path'ine göre güncelle




export default function MobileMenu() {

    const { isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();

    const [categories, setCategories] = useState([]);



    useEffect(() => {
        const loadCategories = async () => {
            try {
                const res = await categoryApi.getCategories();
                setCategories(res.data.categories || []); // örnek yapı: { categories: [...] }
            } catch (error) {
            }
        };

        loadCategories();
    }, []);

    const closeMenu = () => {
        const offcanvasEl = document.getElementById("mobileMenu");
        if (!offcanvasEl) return;

        // bootstrap global değilse window.bootstrap kullanılır
        const bsOffcanvas =
            window.bootstrap?.Offcanvas.getInstance(offcanvasEl) ||
            new window.bootstrap.Offcanvas(offcanvasEl);

        bsOffcanvas.hide();
    };



    const handleLogout = () => {
        logout();
        closeMenu();
        navigate("/"); // anasayfaya yönlendir
    };

    const { pathname } = useLocation();
    const isMenuActive = (link) => {
        return link.href?.split("/")[1] == pathname.split("/")[1];
    };
    const isMenuParentActive = (menu) => {
        return menu.some((elm) => isMenuActive(elm));
    };
    const isMenuParentActive2 = (menu) => {
        return menu.some((elm) => isMenuParentActive(elm.links));
    };
    return (
        <div className="offcanvas offcanvas-start canvas-mb input-page" id="mobileMenu">
            <button
                className="icon-close icon-close-popup"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
            />
            <div className="mb-canvas-content">
                <div className="mb-body">
                    <div className="mb-content-top">

                        <ul className="nav-ul-mb" id="wrapper-menu-navigation">
                            <li className="nav-mb-item">
                                <Link
                                    to="/"
                                    onClick={closeMenu}
                                    className={`mb-menu-link ${isMenuActive("/") ? "menuActive" : ""}`}
                                >
                                    Home
                                </Link>
                            </li>
                            <li className="nav-mb-item">
                                <Link
                                    to="/product-list"
                                    onClick={closeMenu}
                                    className={`mb-menu-link ${isMenuActive("/product-list") ? "menuActive" : ""}`}
                                >
                                    Shop All
                                </Link>
                            </li>
                            <li className="nav-mb-item">
                                <Link
                                    to="/product-list?gender=male"
                                    onClick={closeMenu}
                                    className={`mb-menu-link ${isMenuActive("/product-list") ? "menuActive" : ""}`}
                                >
                                    Men
                                </Link>
                            </li>
                            <li className="nav-mb-item">
                                <Link
                                    to="/product-list?gender=female"
                                    onClick={closeMenu}
                                    className={`mb-menu-link ${isMenuActive("/product-list") ? "menuActive" : ""}`}
                                >
                                    Women
                                </Link>
                            </li>
                            <li className="nav-mb-item">
                                <a
                                    href="#dropdown-menu-categories"
                                    className={`collapsed mb-menu-link`}
                                    data-bs-toggle="collapse"
                                    aria-expanded="false"
                                    aria-controls="dropdown-menu-categories"
                                >
                                    <span>Categories</span>
                                    <span className="btn-open-sub"/>
                                </a>

                                <div id="dropdown-menu-categories" className="collapse">
                                    <ul className="sub-nav-menu">
                                        {categories.map((cat, i) => (
                                            <li key={i}>
                                                <Link
                                                    to={`/product-list?category=${cat.slug}`}
                                                    onClick={closeMenu}
                                                    className="sub-nav-link"
                                                >
                                                    {cat.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </li>
                        </ul>

                    </div>
                    <div className="mb-other-content">

                        <div className="group-icon">
                            {isAuthenticated ? (
                                <>
                                    <Link to="/account-page" onClick={closeMenu} className="site-nav-icon">
                                        <i className="icon icon-user"/>
                                        Account
                                    </Link>

                                    <button
                                        onClick={handleLogout}
                                        className="site-nav-icon  border-0"
                                        style={{color: "inherit", textDecoration: "none"}}
                                    >
                                        <img
                                            src="https://img.icons8.com/?size=100&id=16570&format=png&color=000000"
                                            alt="Logout"
                                            width={20}
                                            height={20}
                                        />
                                        Logout
                                    </button>
                                </>
                            ) : (
                                <a
                                    href="#login"
                                    data-bs-toggle="offcanvas"
                                    className="site-nav-icon"
                                    onClick={closeMenu}
                                >
                                    <i className="icon icon-user"/>
                                    Login
                                </a>
                            )}
                        </div>
                        <div className="mb-notice">
                            <Link to={`/contact-us`} onClick={closeMenu} className="text-need">
                                Need Help?
                            </Link>
                        </div>
                        <div className="mb-contact">
                            <p>Flat 17 Belgrave house 92-94 Belgrave road SW1V 2BJ United Kingdom</p>
                        </div>
                        <ul className="mb-info">
                            <li>
                                Email: <b className="fw-medium">support@luxnco.com</b>
                            </li>
                            <li>
                                Phone: <b className="fw-medium">+44 7542 447873</b>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    );
}
